<template>
  <a-table
    v-if="device !== 'mobile'"
    :columns="columns"
    :data-source="list"
    :pagination="false"
    size="small"
  >
  </a-table>
  <div v-else>
    <a-descriptions bordered v-for="(item,index) in list" :key="index" style="margin-bottom: 20px">
      <a-descriptions-item
        v-for="( itm, i) in columns" :key="`item${i}`"
        :label="itm.title"
      >
        {{item[itm.dataIndex]}}
      </a-descriptions-item>
    </a-descriptions>
  </div>
</template>
<script>
export default {
  data () {
    return {
      visible: true,
      list: [],
      columns: [
        {
          title: '排名',
          dataIndex: 'index',
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '战区',
          dataIndex: 'warZone'
        },
        {
          title: '大区',
          dataIndex: 'region'
        },
        {
          title: '代理商',
          dataIndex: 'agent'
        },
        {
          title: '门店',
          dataIndex: 'name'
        },
        {
          title: '用户',
          dataIndex: 'user'
        },
        {
          title: '电话',
          dataIndex: 'phone'
        },
        {
          title: '销售额',
          dataIndex: 'orderAmount'
        }
      ]
    }
  },
  props: {
    record: Object, // 当前行的数据
    vm: Object, // 触发这个action的组件对象，通常为modelTable或modelTree
    fields: Array, // 当前model的fields对象
    model: Object, // 当前model对象
    className: String, // 当前model的className
    modelName: String, // 当前model的名称
    category: String, // 假如当前model显示为category格式，则会将当前的值传入
    tag: String // 假如当前model显示为tag格式，则会将当前的值传入
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      let { data: res } = await this.$tkParse.post(`/activity/getRanking`, {
        id: this.record.objectId
      })
      res.forEach((e, i) => {
        this.list.push({
          index: i + 1,
          warZone: e.departmentByWarzone.name,
          region: e.department.name,
          agent: e.agentUser.fullName,
          user: e._User.nickName,
          phone: e._User.phone,
          name: e.fullName,
          orderAmount: e.orderAmount
        })
      })
      console.log(this.list)
    },
    cancel () {
      this.$emit('complete', 'cancel')
    }
  }
}
</script>
